module.exports = __webpack_public_path__ + "assets/cb.e73e2763.svg";